// Module
var code = "<button ng-disabled=\"$ctrl.isLoading || !$ctrl.condition\" class=\"btn btn-primary btn-block\" type=\"submit\">\n  <span ng-hide=\"$ctrl.isLoading\" ng-bind=\"$ctrl.caption | translate\"></span>\n  <span ng-show=\"$ctrl.isLoading\">\n    <i class=\"fa fa-spinner fa-spin\"></i>\n  </span>\n</button>\n";
// Exports
export default code;